import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';

@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-tiktok-post-details',
  templateUrl: './tiktok-post-details.component.html',
})
export class TiktokPostDetailsComponent extends DeliverableAnalyticsContentDirective {}
